<template>
  <v-slide-y-transition mode="out-in">
  <v-container fluid>
  <v-card text>
      <v-row dense>
      <v-col cols="12">
        <h1 class="ml-3 mt-2">Add a channel</h1>
      </v-col>
      </v-row>

      <v-row dense>
      <v-col cols="12">
        <v-card
        class="mx-auto"
        max-width="600"
        text
        >

        <v-container fluid style="padding-top: 0px">
          <v-row dense>
            <v-col
            v-for="card in cards"
            :key="card.title"
            :cols="6"
            >
            <v-card
            class="mx-auto"
            outlined
            :color="card.color"
            >
              <v-list-item style="min-height: 100px">
                <v-list-item-content>

                  <v-list-item-text class="headline" v-text="card.title"></v-list-item-text>
                </v-list-item-content>

                <v-list-item-avatar
                tile
                ><v-img :src="card.src"></v-img></v-list-item-avatar>
              </v-list-item>

              <v-card-actions>
                <v-btn color="primary" text>Add</v-btn>
              </v-card-actions>
            </v-card>
            </v-col>
          </v-row>
        </v-container>
        </v-card>
      </v-col>
      </v-row>
  </v-card>
  </v-container>
  </v-slide-y-transition>
</template>

<script>
  export default {
    name: 'future',
    components: {
    },
    data () {
      return {
        cards: [
          { title: 'Facebook & Instagram Ads',
            src: 'https://simpleicons.org/icons/facebook.svg',
            color: 'blue lighten-4' },
          { title: 'Google Ads & Search',
            src: 'https://simpleicons.org/icons/googleads.svg',
            color: 'grey lighten-4' },
          { title: 'Amazon',
            src: 'https://simpleicons.org/icons/amazon.svg',
            color: 'orange lighten-3' },
          { title: 'Snapchat',
            src: 'https://simpleicons.org/icons/snapchat.svg',
            color: 'yellow lighten-3' },
          { title: 'Pinterest',
            src: 'https://simpleicons.org/icons/pinterest.svg',
            color: 'red lighten-4' },
          { title: 'Twitter',
            src: 'https://simpleicons.org/icons/twitter.svg',
            color: 'blue lighten-4' },
          { title: 'LinkedIn',
            src: 'https://simpleicons.org/icons/linkedin.svg',
            color: 'blue lighten-4' },
          { title: 'Programmatic',
            src: 'https://simpleicons.org/icons/mediamath.svg',
            color: 'grey lighten-5' }
        ]
      }
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style scoped>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .switch label {
      color: white!important
    }
</style>
